<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>Vælg installation</dff-side-titel>
    @if (erFilterSynligt$ | async) {
      <panel>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between stretch" fxLayoutGap="15px">
          <installationer-huskeliste
            fxFlex="1 1 auto"
            [fastHuskelisteId]="vm.fastHuskelisteId"
            [control]="huskeliste"
            (valueChange)="onHuskelisteChange()"
          ></installationer-huskeliste>
          <installationer-soeg fxFlex="1 1 auto" [control]="search" (valueChange)="onSoegetekstChange()"></installationer-soeg>
        </div>
      </panel>
    }
    <installation-liste
      id="qa-installationer-liste-component"
      [installationer]="vm.installationer"
      (select)="onSelectInstallation($event)"
    ></installation-liste>
    @if (!vm.eof) {
      <div class="loading-panel">
        @if (!vm.isLoading) {
          <button mat-flat-button color="primary" (click)="loadMore()">Hent flere...</button>
        }
        @if (vm.isLoading) {
          <div>
            <mat-spinner class="mat-spinner" diameter="40"> </mat-spinner>
          </div>
        }
      </div>
    }
  }
  <div #bottomOfTable></div>
</dff-side>
